import React, { useState, useEffect } from 'react';
import BackImage from 'components/BackImage';
import DataHandler from 'config/DataHandler';
import StorageHandler from 'config/StorageHandler';
import { storageKeys } from 'config/settings.json';

import appleStoreLogo from 'assets/images/app_store.png';
import googlePlayLogo from 'assets/images/google_play.png';

const MobileWarning = ({ disabled = false }) => {
  const [appId, setAppId] = useState(0);
  const [appNameDevice, setAppNameDevice] = useState(null);
  const [appleStore, setAppleStore] = useState(null);
  const [googlePlay, setGooglePlay] = useState(null);

  useEffect(() => {
    if (disabled !== true) {
      async function getAppInfo() {
        const appInfo = await StorageHandler.load(storageKeys.appInfo);
        if (appInfo) {
          setAppNameDevice(appInfo.appNameDevice);
          setAppleStore(appInfo.appleStore);
          setGooglePlay(appInfo.googlePlay);
        }
      }
      getAppInfo();
      DataHandler.matchAppId().then((id) => {
        setAppId(id);
      });
    }
  }, [disabled]);

  if (disabled) return null;

  return (
    <div>
      <div className="container__mobileButtons">
        <BackImage darken />
        <div className="container__mobileButtons__holder">
          <h2>{"It looks like you're trying to access the app from a mobile device"}</h2>
          <section>
            {'To download this program simply visit your app store and search for'}
            {` ${appNameDevice}`} {'or click one of the buttons below'}
          </section>
          <h5>{'This will provide you with:'}</h5>
          <ul>
            <li>{'Portability'}</li>
            <li>{'No need for WiFi, train when and where convenient'}</li>
            <li>{'Sales tools & resources at your fingertips'}</li>
          </ul>
          {appleStore && googlePlay && (
            <div className="buttons">
              <a href={appleStore}>
                <img src={appleStoreLogo} alt="App store" />
              </a>
              <a href={googlePlay}>
                <img src={googlePlayLogo} alt="Google Play" />
              </a>
            </div>
          )}
          <hr />
          <span>
            {'App: '}
            {appId}
          </span>
        </div>
      </div>
    </div>
  );
};

export default MobileWarning;
